import { withAIOpsDomainPrefix } from '@atlassian/aiops-common';
import type { Alert, NewSNRPredictionType, SNRActionType } from '@atlassian/eoc-alert-common';
import { fetch } from '@atlassian/eoc-fetch';

import type { EntityRelationTypeResponse, LogTypeResponse } from '../../common/types';

import type { ResponderStatesResponse } from './types';

export const getAlertDetail = (alertId: string): Promise<Alert> =>
	fetch<Alert>(`/v1/alerts/${alertId}`);

export const getAlertLogTypesEndpoint = (): Promise<LogTypeResponse> =>
	fetch<LogTypeResponse>(`/v1/alerts/logs/types`);

export const getResponderStatesEndpoint = (alertId: string): Promise<ResponderStatesResponse> =>
	fetch<ResponderStatesResponse>(`/v1/alerts/${alertId}/responder-states`);

export const getEntityRelationTypesEndpoint = (
	alertId: string,
): Promise<{
	relationTypes: {
		label: string;
		value: string;
	}[];
}> =>
	fetch<EntityRelationTypeResponse>(`/v1/alerts/${alertId}/entity-relations/relation-types`).then(
		(res) => ({
			relationTypes: res.relationTypes.sort((a, b) => a.label.localeCompare(b.label)),
		}),
	);

export const updateAlertSNRDetails = ({
	id,
	prevPrediction,
	newPrediction,
	action,
}: {
	action: SNRActionType;
	id: string;
	newPrediction: NewSNRPredictionType;
	prevPrediction: NewSNRPredictionType;
}): Promise<{
	failedRecords?: number;
	snrResponse: Alert | null;
}> => {
	return fetch<{
		failedRecords?: number;
		snrResponse: Alert | null;
	}>(withAIOpsDomainPrefix(`/v1/alert-insights/${id}/snr-details`), {
		method: 'POST',
		body: {
			id,
			type: 'alert',
			prevPrediction,
			newPrediction,
			action,
		},
		exactUrl: true,
	});
};
